import React, { Component } from 'react';
import { HeaderSub } from '../Common/HeaderSub';
import { Alert, NoResult } from "../../js/ComponentManager";
import { Big3Common, bootstrap } from "../../js/IncludeManager";

import camera from '../../img/camera.svg';
import kakaotalk from '../../img/kakao-talk.svg';

/* 개발담당:양유빈
 * 화면기능:AI 피팅관리
 * 세부설명:
*/

export class AIFittingMgr extends Component {
    static displayName = AIFittingMgr.name;

    constructor(props) {
        super(props);
        this.state = {
            OrderList:[],
            currentPoint: 0,    //누적 포인트
            useablePoint:0,     //사용가는 포인트
            popupShow: false,
            pointCheck: false,
            pointValue: "0",    //포인트 사용 입력값
            contt: "",
            AlertMessage:""
        };
        this.handleKakao_Click = this.handleKakao_Click.bind(this);
        this.RegisterApplication = this.RegisterApplication.bind(this);
        this.handleShowPopup = this.handleShowPopup.bind(this);
        this.handlePointCheck = this.handlePointCheck.bind(this);
        this.handleMoneyChange = this.handleMoneyChange.bind(this);
        this.handleApplicationClick = this.handleApplicationClick.bind(this);
    }
    handleKakao_Click(event) {
        window.open('https://pf.kakao.com/_GxixbKG', "_blank");
        event.preventDefault();
    }
    handleShowPopup = () => {
        this.setState(
            {
                popupShow: !this.state.popupShow,
                contt: "",
                pointValue: "0",
                pointCheck: false
            }
        );
        if (!this.state.popupShow) {
            //팝업 오픈시 포인트 재 조회
            this.GetPointInfo();  
        }
    }
    handlePointCheck = () => {
        this.setState(
            {
                pointCheck: !this.state.pointCheck,
                pointValue:"0"
            }
        )
        if (!this.state.pointCheck) {
            this.GetPointInfo();  
        }
    }
    handleMoneyChange = (e) => {
        const val = e.target.value;
        if (!Big3Common.Util.isNumber(e.target.value) && val !=="") {
            return false;
        }
        this.setState({ pointValue: val });
    }
    handleApplicationClick = async () => {
        //요청하기
        if (this.state.contt === "") {
            this.setState({ AlertMessage: "간단한 전달사항을 입력해주세요."});
            Big3Common.ModalAlert(bootstrap, 'FittingAlert');
            return false;
        }
        if (this.state.pointCheck) {
            const pointvalue = this.state.pointValue;
            if (pointvalue === "" || pointvalue === "0") {
                this.setState({ AlertMessage: "사용하실 포인트를 입력하여 주세요." });
                Big3Common.ModalAlert(bootstrap, 'FittingAlert');
                return false;
            }
            if (parseInt(pointvalue) < 10000) {
                this.setState({ AlertMessage: "포인트 사용은 10,000원 이상부터 사용가능합니다." });
                Big3Common.ModalAlert(bootstrap, 'FittingAlert');
                return false;
            }
            if (pointvalue > this.state.useablePoint) {
                this.setState({ AlertMessage: `현재 사용가능한 포인트는 ${this.state.useablePoint}원 입니다.` });
                Big3Common.ModalAlert(bootstrap, 'FittingAlert');
                return false;
            }
        }
        await this.RegisterApplication();
    }
    async GetAIFittingOrderList() {
        //AI 피팅신청 리스트
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Get(`/api/AIStudio/AIFitting/GetAIFittingOrderList`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.multiDataTable);
                const balancepoint = DataList.BalancePoint;
                const OrderList = DataList.OrderList;
                this.setState({
                    OrderList: OrderList,
                    currentPoint: balancepoint
                })
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetAIFittingOrderList: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        
    }
    async GetPointInfo() {
        //포인트 정보
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Get(`/api/AIStudio/AIFitting/GetPointInfo`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.multiDataTable);
                const balancepoint = DataList.balance_point;
                const useablepoint = DataList.useable_point;
                this.setState({
                    currentPoint: balancepoint,
                    useablePoint: useablepoint
                })
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetPointInfo: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    async RegisterApplication() {
        //AI피팅 등록
        const jsonObject = {
            use_point: parseInt(this.state.pointValue),
            contt: this.state.contt,
            pointcheck: this.state.pointCheck,
            useablepoint: this.state.useablePoint
        }
        let Data = await Big3Common.Post(`/api/AIStudio/AIFitting/RegisterAifittingOrder`, jsonObject);
        if (Data.codeName === Big3Common.ResultCode.Success) {
            this.handleShowPopup();
            this.GetAIFittingOrderList();
        }
        this.setState({ AlertMessage: Data.message });
        Big3Common.ModalAlert(bootstrap, 'FittingAlert');
    }
    //초기화
    componentDidMount() {
        this.GetAIFittingOrderList();
    }
    componentWillUnmount() {
    }
   
    uiRender = {
        // AI 피팅 신청 버튼들
        ServiceButtons: () => {
            return (
                <div className="ai_fitting_service_buttons">
                    <div className="service_button_item">
                        <div className="service_button" onClick={(e) => { this.handleShowPopup(e) }}>
                            <div className="service_icon">
                                <img src={camera } alt="AI 피팅 신청" />
                            </div>
                            <div className="service_title">AI 피팅 신청</div>
                        </div>
                    </div>
                    <div className="service_button_item">
                        <div className="service_button" onClick={(e) => { this.handleKakao_Click(e) }}>
                            <div className="service_icon">
                                <img src={kakaotalk } alt="상담 문의" />
                            </div>
                            <div className="service_title">상담(견적)문의</div>
                        </div>
                    </div>
                </div>
            )
        },
        // 안내 텍스트
        InfoText: () => {
            return (
                <div className="ai_fitting_info">
                    <div className="info_item">
                        <span className="info_icon">✔</span>
                        AI 피팅 신청 전에는 상담 문의를 먼저 진행해 주세요.
                    </div>
                    <div className="info_item">
                        <span className="info_icon">✔</span>
                        AI 피팅 신청이 완료되면, 클로디 담당자가 방문하거나 연락을 드립니다.
                    </div>
                    <div className="info_item">
                        <span className="info_icon">✔</span>
                        포인트 지급은 작업 완료 후 클로디에서 지급해 드립니다(작업 비용에 따라 다름).
                    </div>
                </div>
            )
        },
        // 포인트 내역 테이블
        PointHistory: () => {
            console.log(this.state.OrderList)
            return (
                <div className="point_history_section">
                    <div className="point_header">
                        <h3>잔여 포인트: {Big3Common.Util.Money(this.state.currentPoint)}원</h3>
                    </div>

                    <div className="point_table_wrap">
                        <table className="point_table">
                            <thead>
                                <tr>
                                    <th rowSpan="2">일자</th>
                                    <th colSpan="2">포인트</th>
                                    <th rowSpan="2">상태</th>
                                </tr>
                                <tr>
                                    <th>사용</th>
                                    <th>지급(클로디)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.OrderList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.orddt}</td>
                                        <td style={{ textAlign: "right" }}>{Big3Common.Util.Money(item.use_point)}</td>
                                        <td style={{ textAlign: "right" }}>{Big3Common.Util.Money(item.charge_point)}</td>
                                        <td>{item.fit_status_nm}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <NoResult
                        Visible={this.state.OrderList.length === 0 ? true : false}
                        Top={"70%"}
                    />
                </div>
            )
        },
        AppPopup: () => {
            return (
                <div className="popup-overlay" onClick={this.handleClosePopup}>
                    <div className="popup-container" onClick={(e) => e.stopPropagation()}>
                        <div className="popup-header">
                            <h2>AI 피팅 신청</h2>
                            <button className="close-btn" onClick={this.handleShowPopup}>×</button>
                        </div>
                        <div className="popup-content">
                            <div className="form-section">
                                <label className="form-label">전달 사항</label>
                                <textarea
                                    className="form-textarea"
                                    rows="5"
                                    maxLength="1000"
                                    placeholder="요청사항을 입력해주세요."
                                    value={this.state.contt}
                                    onChange={(e) => { this.setState({ contt: e.target.value })}}
                                />
                            </div>
                            <div className="point-info">
                                <div className="point-notice">
                                    <span className="notice-icon">💎</span>
                                    <span>잔여포인트는 {Big3Common.Util.Money(this.state.currentPoint)}원 이며, 사용가능 포인트는 {Big3Common.Util.Money(this.state.useablePoint)}원 입니다.</span>
                                </div>
                            </div>
                            <div className="point-usage-section">
                                <div className="checkbox-container" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            onClick={() => { this.handlePointCheck() }}
                                        />
                                        <div className="checkmark"></div>
                                    </label>
                                    <div>포인트 사용</div>
                                </div>
                                <div className="point-input-group">
                                    <input
                                        type="text"
                                        maxLength="5"
                                        disabled={!this.state.pointCheck}
                                        value={this.state.pointValue}
                                        onChange={(e) => { this.handleMoneyChange(e) }}
                                        onBlur={(e) => { this.setState({ pointValue: Math.floor(e.target.value / 1000) * 1000 }) }}
                                        className="point-input"
                                    />
                                    <span className="point-unit">(원)</span>
                                </div>
                            </div>
                            <div className="point-notice">포인트 사용은 10,000원 이상부터 가능합니다.</div>
                        </div>

                        <div className="popup-buttons">
                            <button className="btn-cancel" onClick={this.handleApplicationClick}>
                                요청하기
                            </button>
                            <button className="btn-submit" onClick={this.handleShowPopup}>
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            )
        }
    }
    render() {
        return (
            <div>
                <HeaderSub
                    HeaderTitle="AI 피팅관리"
                    LinkUrl="/"
                />
                <div>
                    <div className="ai_fitting_mgr_wrap u_padding">
                        {this.uiRender.ServiceButtons()}
                        {this.uiRender.InfoText()}
                        {this.uiRender.PointHistory()}
                        {this.state.popupShow && this.uiRender.AppPopup()}
                    </div>
                </div>
                <Alert
                    id="Alert"
                    title="카카오톡문의"
                    content="카카오톡에서 친구찾기 [@클로디비즈] 로 검색하세요."
                    zIndex="9999"
                />
                <Alert
                    id="FittingAlert"
                    content=""
                    title={this.state.AlertMessage}
                />
            </div>
        );
    }
}